var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-md-2", staticStyle: { "margin-bottom": "15px" } },
      [
        _c(
          "div",
          { staticClass: "img" },
          [
            _vm.image
              ? _c("lightbox", {
                  attrs: { show: _vm.showLightbox, src: _vm.image },
                  on: {
                    close: function($event) {
                      _vm.showLightbox = false
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.image
              ? _c("img", {
                  staticClass: "img-responsive lightbox",
                  attrs: { src: _vm.image },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.showLightbox = true
                    }
                  }
                })
              : _c("img", {
                  staticClass: "img-responsive",
                  attrs: {
                    src: "/static/images/unknown.png",
                    srcset: "/static/images/unknown@2x.png" + " 2x"
                  }
                })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-10" }, [
      _c("table", { staticClass: "table table-responsive" }, [
        _c(
          "tbody",
          [
            _vm.status
              ? _c("tr", [
                  _c("th", { staticStyle: { "border-top": "none" } }, [
                    _vm._v("Status")
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticStyle: { "border-top": "none" } },
                    [_c("EpcStatus", { attrs: { status: _vm.status } })],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("gtin")))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.product.gtin))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("brand_name")))]),
              _vm._v(" "),
              _c(
                "td",
                [
                  typeof _vm.product.brandName !== "undefined" &&
                  _vm.product.brandName.length > 0
                    ? _vm._l(_vm.product.brandName, function(brandName) {
                        return _c(
                          "lang-string",
                          {
                            key: brandName.language,
                            attrs: {
                              lang: brandName.language,
                              value: brandName.value
                            }
                          },
                          [_c("br")]
                        )
                      })
                    : _c("span", { staticClass: "unknown" }, [
                        _vm._v(_vm._s(_vm.$t("unknown")))
                      ])
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("product_description")))]),
              _vm._v(" "),
              _c(
                "td",
                [
                  typeof _vm.product.description !== "undefined" &&
                  _vm.product.description.length > 0
                    ? _vm._l(_vm.product.description, function(description) {
                        return _c(
                          "lang-string",
                          {
                            key: description.language,
                            attrs: {
                              lang: description.language,
                              value: description.value
                            }
                          },
                          [_c("br")]
                        )
                      })
                    : _c("span", { staticClass: "unknown" }, [
                        _vm._v(_vm._s(_vm.$t("unknown")))
                      ])
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("product_image_url")))]),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "overflow-hidden" },
                [
                  typeof _vm.product.image !== "undefined" &&
                  Array.isArray(_vm.product.image) &&
                  _vm.product.image.length > 0
                    ? _vm._l(_vm.product.image, function(image) {
                        return _c(
                          "lang-string",
                          {
                            key: image.language,
                            attrs: {
                              lang: image.language,
                              value: image.value,
                              tag: "a",
                              href: image.value,
                              target: "_blank",
                              rel: "noopener"
                            }
                          },
                          [_c("br")]
                        )
                      })
                    : _c("span", { staticClass: "unknown" }, [
                        _vm._v(_vm._s(_vm.$t("unknown")))
                      ])
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("global_product_category")))]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _vm.product.gpc
                    ? [_vm._v(_vm._s(_vm.product.gpc))]
                    : _c("span", { staticClass: "unknown" }, [
                        _vm._v(_vm._s(_vm.$t("unknown")))
                      ])
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("net_content")))]),
              _vm._v(" "),
              _c(
                "td",
                [
                  typeof _vm.product.netContents !== "undefined" &&
                  Array.isArray(_vm.product.netContents) &&
                  _vm.product.netContents.length > 0
                    ? [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.product.netContents.join(", ")
                            )
                          }
                        })
                      ]
                    : _c("span", { staticClass: "unknown" }, [
                        _vm._v(_vm._s(_vm.$t("unknown")))
                      ])
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$tc(
                        "country_of_sale",
                        _vm.product.countriesOfSale.length
                      )
                    ) +
                    "\n          "
                )
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _vm.product.countriesOfSale.length > 0
                    ? [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.product.countriesOfSale.join(", ")) +
                            "\n            "
                        )
                      ]
                    : _c("span", { staticClass: "unknown" }, [
                        _vm._v(_vm._s(_vm.$t("unknown")))
                      ])
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("links-tr", { attrs: { linkSet: _vm.linkSet } }, [
              _vm._v(_vm._s(_vm.$t("targets")))
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", { staticStyle: { "border-bottom": "0" } }, [
                _vm._v(_vm._s(_vm.$t("last_update")))
              ]),
              _vm._v(" "),
              _c("td", { staticStyle: { "border-bottom": "0" } }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.saveGet(this.product, "", "updatedOn")) +
                    "\n          "
                )
              ])
            ])
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3cf4ef6f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cf4ef6f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Product.vue
// module id = null
// module chunks = 